import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { useParams} from 'react-router-dom';
import { getAxiosResponse, putOrPostAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { dateConvertToTimeStamp, transformBlankToNull } from "../../services/Util";
import TreeView from "../../pages/TreeView";
import Constants from "../../Constants";
import { updateTreeValue, updateTab, updateTreeData, addChildrenToTreeData ,setSelectedTreeData} from "../../redux/reducers/TreeSlice";
import { updateCredentialsSet, updateProjectContentType } from "../../redux/reducers/ProjectInfoSlice"
import BrightcoveCredential from "../../pages/settings/integrationSettings/BrightcoveCredential";
import jQuery from "jquery";
import { RotatingLines } from "react-loader-spinner";
import SuccessMessage from "../../components/SuccessMessage";
import { logError } from "../../services/authApiRoutes/APImethods";
import { handleError } from "../../services/authApiRoutes/APImethods";

export default function BrightcoveIntegration(props) {
  const params = useParams();
  const TreeViewMemo = React.memo(TreeView);
  const dispatch = useDispatch();
  const BrightcoveCredentialMemo = React.memo(BrightcoveCredential);
  const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
  const [showTree, setShowTree] = useState(false);
  const [folderAssets, setFolderAssets] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [childData, setChildData] = useState();
  const [showCredential, setShowCredential] = useState(false);
  const [isValidating, setValidating] = useState(false);
  const [credentialData, setCredentialData] = useState();
  const [successMessage, setSuccessMessage] = useState(Constants.BLANK);
  const [message, setMessage] = useState(Constants.BLANK);
  const [serverErrorMessage, setServerErrorMessage] = useState([]);

  const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;
  const dispatchDataToTreeSliceRedux = (type, value) => {		
		dispatch(updateTreeValue({
		  type: type,
		  value: value
		}));
	}

  const showCredentialModel = () => {
    setShowCredential(true);
    setShowTree(false);
    setServerErrorMessage([])
    document.body.classList.add("modal-open");
  };

  const hideCredentialModel = () => {
    setShowCredential(false);
    setValidating(false);
    setServerErrorMessage([])
    dispatchDataToTreeSliceRedux("isTreeLoading", false);
    document.body.classList.remove("modal-open");
    jQuery(".integration-check-input").prop("checked", false);
  };
  const selectedTreeData = useSelector(reduxStore => reduxStore.tree_structure).selectedTreeData
  const projectData = useSelector((reduxStore) => reduxStore.project_info).value;

  useEffect(() => {
    //getCredential(Constants.BRIGHTCOVE);
    loadBrightcoveTree();
    if(custBootstrapDataRedux?.roleSet?.customerProjectRequester){
      dispatchDataToTreeSliceRedux("selectedTreeNode", {});

   }
    if(selectedTreeData && selectedTreeData.length===0){
      getExistingSelection("BRIGHTCOVE")
       }
  }, []);

  const getExistingSelection = (service) => {
    const dateTimestamp = dateConvertToTimeStamp();
    if (props?.projectRequestId || projectData?.id) {
      let urlString = APIUrls.CUSTOMER_PROJECT_ASSET_CONFIGURATION(params.id);
      if (props.isProjectRequest && props.projectRequestId) {
        urlString = APIUrls.CUSTOMER_PROJECT_REQUEST_ASSET_CONFIGURATION(props.projectRequestId)
      }
      getAxiosResponse(urlString + `?type=${service}&_=${dateTimestamp}`
      ).then((res) => {
        if (res.data.code === 200) {
          let data = []
          if (res.data?.data?.body && res.data?.data?.body?.length > 0) {
            res.data?.data?.body?.forEach(asset => {
              if ((asset.language === null) || (asset.language !== projectData?.sourceLanguage)) {
                data?.push(asset);
              }
            })
            const result = Object.values(data.reduce((acc, curr, index) => {
              if (!acc[curr.externalId]) {
                acc[curr.externalId] = { ...curr, assetName:curr?.name,language: [curr.language] };
              } else {
                if (!acc[curr.externalId].language.includes(curr.language)) {
                  acc[curr.externalId].language.push(curr.language);
                }
              }
              return acc;
            }, {}));
            result?.map(r => r.assetName = r.name);
            dispatch(setSelectedTreeData(result))
          }
        }
      }).catch((err) => {
        handleError(err);
      });
    }
  };

  useEffect(() => {
    const asset = treeValueRedux?.selectedTreeNode;
    if (asset?.assetId !== undefined) {
      if (asset?.assetType === Constants.FOLDER) {
        getFolderChildren(asset.assetId, 0, 0, setChildData);
      } else {
        getVideoChidlren(asset.assetId, asset.assetType, 0, 0, setChildData);
      }
    }
  }, [treeValueRedux.selectedTreeNode])

  useEffect(() => {
    if (Array.isArray(childData) && childData.length > 0) {
      let cloneNode = JSON.parse(JSON.stringify(treeValueRedux.selectedTreeNode))
      cloneNode.children = childData;
      dispatch(addChildrenToTreeData(cloneNode))
    }
  }, [childData])

  useEffect(() => {
    if (treeValueRedux.searchText !== undefined && treeValueRedux.searchText?.length > 0) {
      getVideo(0, 0, treeValueRedux.searchText, treeValueRedux.searchTypeValue, setFolderAssets)
    } else {
      if(treeValueRedux.searchText === ""){  
        getFolders(0, 0, setFolderAssets);
      }
    }
    
  }, [treeValueRedux.searchText])

  const getPreference = (preference, setValue) => {
		const dateTimestamp = dateConvertToTimeStamp();
		getAxiosResponse(
			APIUrls.CUSTOMER_ORG_PREFERENCE + `?=${preference}&_=${dateTimestamp}`
		).then(res => {
			if (res.data.code === 200) {
				const preference = transformBlankToNull(res.data.data);
				setValue(preference);
			}
		}).catch(err => {
			handleError(err);
		})
  }

  const getFolders = (limit, offset, setValue) => {
    setValidating(true);
    setMessage("Fetching data...")
    const dateTimestamp = dateConvertToTimeStamp();
    let urlString = APIUrls.BRIGHTCOVE_FOLDERS(params.id);
    if (props.isProjectRequest) {
      urlString = APIUrls.BRIGHTCOVE_FOLDERS_PROJECTLESS(props.department?.id)
    }
    getAxiosResponse(urlString + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`
    ).then((res) => {
      setValidating(false);
      setMessage(Constants.BLANK)
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
      if (res.data.code === 200) {
        let assetList = getAssets(res.data.data.body.assetTypeResponseList);
        dispatch(updateTreeData(assetList))  
        setValue(assetList);
      } else {
        showCredentialModel();
        setValidating(false);
        
      }
    }).catch((err) => {
        handleError(err);
        dispatchDataToTreeSliceRedux("isTreeLoading", false);
        setValidating(false);
        setMessage(Constants.BLANK)
    });
  };

  const getAssets = (assetTypeResponseList) => {
    let assetList = [];
    assetTypeResponseList?.map(asset => {
      asset.assetList.map(a => {
        a.assetType = asset.assetType;
        a.id = a.assetId;
        a.children = [];
        a.parentAssetUrl = treeValueRedux.selectedTreeNode?.assetUrl;
        a.parentAssetType = treeValueRedux.selectedTreeNode?.assetType;
        assetList.push(a)
      }); 
    })
    return assetList;
  }

  const getFolderChildren = (folderId, limit, offset, setValue) => {
    const dateTimestamp = dateConvertToTimeStamp();
    dispatchDataToTreeSliceRedux("isTreeLoading", true);
    let urlString = APIUrls.BRIGHTCOVE_FOLDER_CHILDREN(params.id, folderId)
    if (props.isProjectRequest) {
      urlString = APIUrls.BRIGHTCOVE_FOLDER_CHILDREN_PROJECTLESS(props.department?.id, folderId)
    }
    getAxiosResponse(urlString + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`
    ).then((res) => {
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
        if (res.data.code === 200) {
          let assetList = getAssets(res.data.data.body.assetTypeResponseList);
          setValue(assetList);
        }
    }).catch((err) => {
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
      handleError(err);
    });
  };

  const getVideo = (limit, offset, searchText, searchType, setValue) => {
    const dateTimestamp = dateConvertToTimeStamp();
    dispatchDataToTreeSliceRedux("isTreeLoading", true);
    let urlString = APIUrls.BRIGHTCOVE_ASSET(params.id)
    if (props.isProjectRequest) {
      urlString = APIUrls.BRIGHTCOVE_ASSET_PROJECTLESS(props.department?.id)
    }
    getAxiosResponse(urlString + `?limit=${limit}&offset=${offset}&searchText=${searchText}&searchType=${searchType}&_=${dateTimestamp}`
    ).then((res) => {
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
        if (res.data.code === 200) {
          let assetList = getAssets(res.data.data.body.assetTypeResponseList);
          dispatch(updateTreeData(assetList)) 
          setValue(assetList);
        }
    }).catch((err) => {
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
      handleError(err);
    });
  }

  const getVideoChidlren = (videoId, assetType, limit, offset, setValue) => {
    const dateTimestamp = dateConvertToTimeStamp();
    dispatchDataToTreeSliceRedux("isTreeLoading", true);
    let urlString = APIUrls.BRIGHTCOVE_ASSET_CHILDREN(params.id, videoId, assetType)
    if (props.isProjectRequest) {
      urlString = APIUrls.BRIGHTCOVE_ASSET_CHILDREN_PROJECTLESS(props.department?.id, videoId, assetType)
    }
    getAxiosResponse(urlString + `?limit=${limit}&offset=${offset}&_=${dateTimestamp}`
    ).then((res) => {
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
        if (res.data.code === 200) {
          let assetList = getAssets(res.data.data.body.assetTypeResponseList);
          setValue(assetList);
        }
    }).catch((err) => {
      dispatchDataToTreeSliceRedux("isTreeLoading", false);
      handleError(err);
    });
  }

  const getCredential = (service) => {
    setValidating(true)
    setMessage("Checking credentials...")
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(
      APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(service) + `?_=${dateTimestamp}`
    ).then((res) => {
      setValidating(false)
      if (res.data.code === 200) {
        var credentialsSet = transformBlankToNull(res.data.data.body)
        if (credentialsSet !== null && credentialsSet.credentials !== null) {
          setCredentialData(credentialsSet)
          dispatch(updateCredentialsSet(credentialsSet))
          dispatch(updateProjectContentType(Constants.BRIGHTCOVE));
          loadBrightcoveTree();
        } else {
          showCredentialModel();
        } 
      }
    }).then((err) => {
      handleError(err);
      setMessage(Constants.BLANK)
      handleError(err);
      setValidating(false)
    })
  };

  const loadBrightcoveTree = () => {
    setMessage("Please wait, your assets are being loaded...")
    dispatch(updateTab([
      {
        label: "Folders",
        isActive: true
      }
    ]));
    if(custBootstrapDataRedux?.roleSet?.customerProjectRequester){
      dispatch(setSelectedTreeData([]));
     }
    dispatchDataToTreeSliceRedux("selectedTreeNode", {});
    dispatchDataToTreeSliceRedux("displayName", "assetName");
    dispatchDataToTreeSliceRedux("contentType", Constants.BRIGHTCOVE_CONTENT_TYPE_DISPLAY);
    dispatchDataToTreeSliceRedux("isTreeLoading", true);
    getFolders(0, 0, setFolderAssets)
  };

  const onTabChange = (tab) => {
    tabs.map((t) => {
      if (t.label === tab.label) {
        t.isActive = true;
      } else {
        t.isActive = false;
      }
    });
    setTabs(tabs);
  };

  const submitCredential = (isForSystemUser) => {
    if(!validateCredential()) {
      return;
    }
    setSuccessMessage("Validating credentials...")
    setValidating(true);
    var isPost = true;
    var urlString;
    let localCredentialData = credentialData; //isForSystemUser ? systemUserCredentialData : credentialData;    
    let dataToSave = {credentials:{
      ACCOUNT_ID : jQuery.trim(jQuery("#brightcove-account-id-input").val()),
      CLIENT_ID : jQuery.trim(jQuery("#brightcove-client-id-input").val()),
      CLIENT_SECRET : jQuery.trim(jQuery("#brightcove-client-secret-input").val()) 	  
    }, credentialsType: "BRIGHTCOVE"};

    if(isForSystemUser){
      //dataToSave.selectedUserGroupId = department?.id;
      //dataToSave.dataGroupId = department?.id;
      //urlString = APIUrls.CUSTOMER_EXTERNAL_SYSTEM_USER_CREDENTIALS(Constants.BRIGHTCOVE) + `?userGroupId=${department?.id}`;
    } else {
      urlString = APIUrls.CUSTOMER_EXTERNAL_SERVICE_CREDENTIALS(Constants.BRIGHTCOVE);
    }	  			   
    
    if(localCredentialData?.id){
      isPost = false;
      dataToSave.id = localCredentialData?.id;
    }

    putOrPostAxiosResponse(urlString, dataToSave, isPost
      ).then((res) => {
        setSuccessMessage(Constants.BLANK)
        setValidating(false);
        if (res.data?.handledMessage || res.data?.data?.handledMessage){
          setServerErrorMessage([res.data.handledMessage])
        } else {
          setServerErrorMessage([])
          setSuccessMessage("Credential successfully updated!")
          hideCredentialModel();
          loadBrightcoveTree();
        }
      }).catch((err) => {
        setValidating(false);
        setSuccessMessage(Constants.BLANK)
        const errorMessage = "err - ";
        logError(errorMessage, err);  
      })
  }

  const validateCredential = () => {
    setServerErrorMessage([]);
    let errorMsgs = [];

    if (jQuery.trim(jQuery("#brightcove-account-id-input").val()) == ""){
      errorMsgs.push("Please enter account id for Brightcove.")
    } 
    if (jQuery.trim(jQuery("#brightcove-client-id-input").val()) == ""){
      errorMsgs.push("Please enter client id for Brightcove.");
    }
    if (jQuery.trim(jQuery("#brightcove-client-secret-input").val()) == ""){
      errorMsgs.push("Please enter client secret for Brightcove.");
    }  
    if (errorMsgs.length > 0) {
      setServerErrorMessage(errorMsgs);
      return false;
    } else {
      setServerErrorMessage([]);
      return true;
    }
  }

  return (
    <>
    <div className={isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
        <RotatingLines
          strokeColor="#0096FF"
          strokeWidth="5"
          width="196"
          visible={true}
        />
      </div>
    </div> 
    {(message!==undefined && message !== Constants.BLANK)?<SuccessMessage message={message}/>:Constants.BLANK}

    {showCredential ? 
    (<div className="lightbox-panel sm-lg-lightbox-panel">
    <div className="inner-lightbox-panel pb-0">
    <div className="modal-header flex padd-lr">
      <strong>Brightcove integration settings</strong>
      <button className="close" aria-label="close popup" onClick={() => hideCredentialModel()}>
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z" fill="white"></path><path d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z" fill="white"></path></svg>
      </button>
    </div>
    <div className="lightbox-content padd-22">
        <div className="flex">
        <div className="leftBlock">
            <p>OPAL-Marketing accelerates and automates the localization process by integrating directly with Brightcove. 
            The integration allows videos to be transcribed using OPAL-Marketing to generate a VTT or SRT file. 
            The subtitles can subsequently be translated into the desired languages and an in-context review can take place allowing reviewers to edit and comment on the subtitles. 
            After the translations have been approved, OPAL-Marketing automatically updates Brightcove with the translated subtitle files.</p>
        </div>
        <div className="rightBlock">
          <div className="flex wrap-dropdown flex-column mb-0">
            <BrightcoveCredentialMemo 
              credentialData = {credentialData} 
              errorMessages = {serverErrorMessage}
              isValidating = {isValidating}
              successMessage = {successMessage}
              closePopup = {hideCredentialModel}
            />
          </div>
        </div>
        
        </div>
    </div>	
    <div className="modal-footer modal-footer-border flex px-22">
          <button className="btn btn-bold" onClick={() => hideCredentialModel()}>Cancel</button>
          <button id="save-credential" className="btn btn-bold active" onClick={() => submitCredential(false)}>Save</button>
      </div>
    </div>		
    </div>) 
    :
    (<div>
      <TreeViewMemo onTabChange={onTabChange} />
    </div>) 
    }
  </>  
    
  );
}
